export enum aiQueryKeys {
  getBusinessChatGptInterviewVoiceHistory = "getBusinessChatGptInterviewVoiceHistory",
  getBusinessChatGptInterviewHistory = "getBusinessChatGptInterviewHistory",
}
